var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.406506 0.383993C0.156879 0.629937 0.0166468 0.963464 0.0166468 1.31123C0.0166468 1.659 0.156879 1.99252 0.406506 2.23847L8.78593 10.4918L0.406507 18.7451C0.27933 18.8661 0.177889 19.0108 0.108104 19.1708C0.0383193 19.3309 0.00158749 19.503 5.11345e-05 19.6771C-0.00148522 19.8512 0.0322055 20.0239 0.0991569 20.1851C0.166108 20.3463 0.26498 20.4927 0.390002 20.6159C0.515025 20.739 0.663694 20.8364 0.827336 20.9023C0.990979 20.9683 1.16632 21.0015 1.34312 21C1.51992 20.9984 1.69465 20.9623 1.8571 20.8935C2.01955 20.8248 2.16648 20.7249 2.28931 20.5996L11.6101 11.419C11.8598 11.1731 12 10.8396 12 10.4918C12 10.144 11.8598 9.81051 11.6101 9.56456L2.28931 0.383993C2.03961 0.138122 1.70099 -7.43525e-08 1.34791 -5.8919e-08C0.994831 -4.34854e-08 0.656208 0.138122 0.406506 0.383993Z",
    fill: "#68717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.6ad854dfe2f806529ad2d44275c95d61.svg";
export { ForwardRef as ReactComponent };